document.documentElement.classList.remove('no-js');

function velocityMailto(form, subject, lines) {
  const data = new FormData(form);
  const value = (name, fallback = 'Not provided') => String(data.get(name) || fallback);
  const body = lines.map((line) => typeof line === 'function' ? line(value) : line).join('\n');
  window.location.href = `mailto:Sales@VelocityCustomsLLC.com?subject=${encodeURIComponent(subject(value))}&body=${encodeURIComponent(body)}`;
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-mobile-menu-button]');
  if (!button) return;
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;
  const open = menu.hasAttribute('hidden');
  menu.toggleAttribute('hidden', !open);
  button.setAttribute('aria-expanded', String(open));
  button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
});

document.addEventListener('click', (event) => {
  const projectLink = event.target.closest('[data-project-type]');
  if (projectLink) {
    const select = document.querySelector('[data-quick-quote] [name="project_type"]');
    if (select) select.value = projectLink.dataset.projectType;
  }

  if (!event.target.closest('[data-mobile-menu] a')) return;
  const menu = document.querySelector('[data-mobile-menu]');
  const button = document.querySelector('[data-mobile-menu-button]');
  if (menu) menu.setAttribute('hidden', '');
  if (button) button.setAttribute('aria-expanded', 'false');
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;

  if (form.matches('[data-quick-quote]')) {
    event.preventDefault();
    velocityMailto(form, (value) => `Quote request: ${value('project_type', 'Custom project')}`, [
      (value) => `Name: ${value('name')}`,
      (value) => `Best contact: ${value('contact')}`,
      (value) => `Project: ${value('project_type', 'Custom project')}`,
      (value) => `Approximate size / quantity: ${value('size')}`,
      '', 'Project details:', (value) => value('details', '')
    ]);
  }

  if (form.matches('[data-wrap-quote]')) {
    event.preventDefault();
    const panelNames = String(form.dataset.panels || '').split(',').filter(Boolean);
    const panelLabels = String(form.dataset.panelLabels || '').split('|');
    const isCar = form.dataset.variant === 'car';
    const lines = [
      String(form.dataset.emailSubject || 'Wrap quote request').toUpperCase(), '',
      (value) => `Customer: ${value('name')}`,
      (value) => `Best contact: ${value('contact')}`,
      (value) => `City / state: ${value('location')}`,
      (value) => `Vehicle type: ${value('vehicle_type')}`,
      (value) => `Class: ${value('class')}`,
      (value) => `Chassis / body manufacturer: ${value('manufacturer')}`,
      (value) => `Body model and year: ${value('model_year')}`,
      (value) => `Coverage wanted: ${value('coverage')}`,
      (value) => `Measurement status: ${value('measurement_status')}`
    ];
    if (isCar) lines.push((value) => `Deadline / race date: ${value('deadline')}`);
    lines.push('', 'PANEL MEASUREMENTS (INCHES)');
    panelNames.forEach((name, index) => lines.push((value) => `${panelLabels[index] || name}: ${value(name)}`));
    lines.push('', 'DESIGN INFORMATION',
      (value) => `Race number: ${value('number')}`,
      (value) => `Driver name: ${value('driver')}`,
      (value) => `Main colors: ${value('colors')}`,
      (value) => `Style / theme: ${value('style')}`,
      (value) => `Sponsor count: ${value('sponsor_count')}`,
      '', 'PROJECT NOTES', (value) => value('details'), '',
      'I will attach available photos, logos, and inspiration images to this email.'
    );
    velocityMailto(form, (value) => `${form.dataset.emailSubject} – ${value('name')}`, lines);
  }
});
